import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'
import vClickOutside from "click-outside-vue3"
require('@/assets/css/bootstrap.min.css')
const app = createApp(App);
  app.use(vuetify).use(vClickOutside)
  .mount('#evaluateurSunethic')
